export const flagshipTemplate = `
<div class="criteo-flagship-container">
  <div class="criteo-flagship-content">
    <!-- Brand/Creative Zone (Left) -->
    <div class="criteo-flagship-brand">
      <a class="flagship-brand-content flagship-brand-cta" href="">
        <img class="flagship-brand-image" src="" alt="" loading="lazy" />
      </a>
    </div>

    <!-- Products Zone (Right) -->
    <div class="criteo-flagship-products">
      <!-- Products will be injected here -->
    </div>
  </div>
</div>
`;

export const flagshipProductCardTemplate = `
<div class="flagship-product-card">
  <a class="flagship-product-link" href="" title="">

    <!-- Product image (left column) -->
    <div class="flagship-product-image-wrapper">
      <img class="flagship-product-image" src="" alt="" loading="lazy" />
    </div>

    <!-- Product info + price (right column) -->
    <div class="flagship-product-info-wrapper">
      <div class="flagship-product-info">
        <h4 class="flagship-product-title"></h4>
        <div class="flagship-product-rating">
          <div
            data-bv-show="rating_summary"
            data-bv-product-id=""
          ></div>
        </div>
      </div>

      <div class="flagship-product-price">
        <!-- Price will be inserted here -->
      </div>

      <div class="product-energy-tag">
        <!-- Energy tag will be inserted here -->
      </div>
    </div>
  </a>
</div>
`;
